// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/widgets/action/universal-io/app/schema-builder/app/css/app.css
// module id = 708
// module chunks = 0